declare let mxCellMarker: any;

export class CellsHighlighter {
  private graph;
  private opts = {
    hlColor: '#0afaf2',
    hlOpacity: 50,
    hlWidth: 5,
    hlDuration: 1500
  };
  private markers = [];
  private timer;

  constructor(graph, opts = {}) {
    this.graph = graph;
    this.opts = {...this.opts, ...opts};
  }

  highlightWithTimeout(cells = []) {
    this.clearAll();
    this.markers = cells.map(cell => {
      const marker = this.createMarker();

      marker.markCell(cell);

      return marker;
    });
    this.timer = setTimeout(() => this.clearAll(), this.opts.hlDuration);
  }

  highlight(cells = []) {
    this.markers = cells.map(cell => {
      const marker = this.createMarker();

      marker.markCell(cell);

      return marker;
    });
  }

  clearAll() {
    clearTimeout(this.timer);
    this.markers.forEach(m => m.destroy());
  }

  private createMarker() {
    const hlMarker = new mxCellMarker(this.graph, this.opts.hlColor);

    hlMarker.highlight.strokeWidth = this.opts.hlWidth;
    hlMarker.highlight.opacity = this.opts.hlOpacity;

    return hlMarker;
  }
}
